/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimelineContent } from '../../models/timeline-content';

export interface ApiMasterTimelineContentGetAllGet$Params {
}

export function apiMasterTimelineContentGetAllGet(http: HttpClient, rootUrl: string, params?: ApiMasterTimelineContentGetAllGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimelineContent>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterTimelineContentGetAllGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<TimelineContent>>;
    })
  );
}

apiMasterTimelineContentGetAllGet.PATH = '/api/Master/TimelineContent/GetAll';
